import { render, staticRenderFns } from "./TableLegend.vue?vue&type=template&id=74137a7e"
import script from "./TableLegend.vue?vue&type=script&lang=js"
export * from "./TableLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports